/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  EditGroup: (params: vp.EditGroupRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEditGroup: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEditGroup, setShouldEditGroup] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EditGroupRequest>({
    GroupName: '',
    Description: '',
    GroupID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldEditGroup) return () => {};

    const PostEditGroup = async () => {
      setDataFetchingInfo(true, 'editing group', 'fullScreen');
      const res = await api.postEditGroup(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEditGroup) void PostEditGroup();
    setShouldEditGroup(false);
    return () => {
      source.cancel();
    };
  }, [shouldEditGroup]);

  return [
    response,
    (_params: vp.EditGroupRequest) => {
      setParams(_params);
      setShouldEditGroup(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldEditGroup(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEditGroup);